// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 36) return "static/js/8931c89b1ce02c4faa58.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"beecb75b3b364bd06a32","137":"0a1dda413e3d8d1610d8","138":"be8b3d42b2aef5ea888a"}[chunkId] + ".chunk.js";
};